export default {
  list: (state) => {
    return state.list
  }
  // listHomePage: (state) => {
  //   let frontPageListings = []

  //   let array = ['1', '2', '3']
  //   array.forEach((index) => {
  //     let listing = state.list.find((listing) => {
  //       return listing.frontPagePosition === index
  //     })
  //     if (listing) {
  //       frontPageListings.push(listing)
  //     }
  //   })

  //   return frontPageListings
  // }
}
